import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import useVerifyUser from './api/verify_user';
import Header from './elements/Header';
import Footer from './elements/Footer';
import About from './elements/About';
import Contact from './elements/Contact';
import News from './elements/News';
import Model from './elements/model/Model';
import ModelEdit from './elements/model/ModelEdit';
import Models from './elements/model/Models';
import Become from './elements/Become';
import LogInLightBox from './containers/LogInLightBox';
import OneLightBox from './elements/lightbox/OneLightBox';
import './App.css';

const Routes = () => (
  <Switch>
    <Route path="/" exact component={News} />
    <Route path="/lightbox/:hash" exact component={OneLightBox} />
    <Route path="/lightbox" exact component={LogInLightBox} />
    <Route path="/:type/:category/:gallery/:name/edit" exact component={ModelEdit} />
    <Route path="/:type/:category/:gallery/:name" exact component={Model} />
    <Route path="/:type/:category" exact component={Models} />
    <Route path="/become-a-model" component={Become} />
    <Route path="/about" component={About} />
    <Route path="/contact" component={Contact} />
    <Route path="/news" component={News} />
  </Switch>
);

export default ({ login, logout }) => {
  useVerifyUser(login, logout);
  return (
    <Router>
      <div className="margin">
        <Header />
        <div className="main_frame">
          <Routes />
        </div>
        <Footer />
      </div>
    </Router>
  );
};
